import * as API from "@/services/API";

export default {
  getAStatements() {
    return API.apiClient.get(`/fchartstatementa`);
  },
  getBStatements() {
    return API.apiClient.get(`/fchartstatementb`);
  },
  getCStatements() {
    return API.apiClient.get(`/fchartstatementc`);
  },
  getDStatements() {
    return API.apiClient.get(`/fchartstatementd`);
  },
  getEStatements() {
    return API.apiClient.get(`/fchartstatemente`);
  },
  getFStatements() {
    return API.apiClient.get(`/fchartstatementf`);
  },
  getGStatements() {
    return API.apiClient.get(`/fchartstatementg`);
  },
  getHStatements() {
    return API.apiClient.get(`/fchartstatementh`);
  },
  getIStatements() {
    return API.apiClient.get(`/fchartstatementi`);
  },
  getJStatements() {
    return API.apiClient.get(`/fchartstatementj`);
  },
  getKStatements() {
    return API.apiClient.get(`/fchartstatementk`);
  },
  getLStatements() {
    return API.apiClient.get(`/fchartstatementl`);
  },
  getMStatements() {
    return API.apiClient.get(`/fchartstatementm`);
  },
  getNStatements() {
    return API.apiClient.get(`/fchartstatementn`);
  },
  getOStatements() {
    return API.apiClient.get(`/fchartstatemento`);
  },
}
